import { _RULES } from "@/store/_RULES"

/*
FIELD = {
  label: String //Nome a mostrar na label do campo,
  name: String //Nome do campo na base de dados,
  type: String //Tipo de campo,
  size: Object //Valores para dimensionamento,
  rules: Array //Regras para preenchimento do campo,
  all: Boolean //Se num autocomplete mostra todos os dados ou não,
  disabled: Array //Grupo de utilizadores em que o campo vai estar disabled
}


TYPES = {
  text: input normal,
  tipos: select para tipos de utilizador,
  instituicoes: select para instituicoes,
  brigadas: select para brigadas,
  dadivas: select para dadivas,
  data: input para data,
  password: campos para password e confirmar password
}
*/

// -- FIELDS
const _FIELDS = [
  {
    title: "Dados Utilizador",
    type: "subheader",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    }
  },
  {
    label: "Nome",
    name: "nome",
    type: "text",
    size: {
      cols: 8,
      sm: 8,
      md: 8
    },
    rules: [_RULES.required]
  },
  {
    title: "Data Nascimento",
    type: "data",
    name: "data_nasc",
    size: {
      cols: 4,
      sm: 4,
      md: 4
    },
    rules: [_RULES.required]
  },
  {
    label: "Cartão cidadão",
    name: "cc",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.isNumber]
  },
  {
    label: "NIF",
    name: "nif",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.isNumber]
  },
  {
    label: "SNS",
    name: "sns",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.isNumber]
  },
  {
    label: "Nacionalidade",
    name: "id_nacionalidade",
    type: "array",
    store: "nacionalidade",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    label: "Género",
    name: "id_genero",
    type: "array",
    store: "genero",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    label: "Estado civil",
    name: "id_estado_civil",
    type: "array",
    store: "estado_civil",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    label: "Telefone",
    name: "telefone",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: []
  },
  {
    label: "Telemóvel",
    name: "telemovel",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: []
  },
  {
    type: "dcl",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: [_RULES.required]
  },
  {
    title: "Dados Dador",
    type: "subheader",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    }
  },
  {
    label: "Nº nacional dador",
    name: "n_nac",
    type: "text",
    size: {
      cols: 4,
      sm: 4,
      md: 4
    },
    rules: []
  },
  {
    label: "Dádivas iniciais",
    name: "dadivas_iniciais",
    type: "text",
    size: {
      cols: 4,
      sm: 4,
      md: 4
    },
    rules: []
  },
  {
    label: "Grupo sanguíneo",
    name: "id_gs",
    type: "array",
    store: "gs",
    size: {
      cols: 4,
      sm: 4,
      md: 4
    },
    rules: [_RULES.required]
  },
  {
    title: "Dados Acesso",
    type: "subheader",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    }
  },
  {
    label: "Tipo utilizador",
    name: "id_tipo_utilizador",
    type: "array",
    store: "tipo_utilizador",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    name: "instituicoes",
    type: "instituicoes",
    store: "instituicao",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required],
    all: true,
    multiple: true
  },
  {
    label: "Email",
    name: "email",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: [_RULES.required, _RULES.email]
  },
  {
    type: "password",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: []
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "E-Mail",
    align: "left",
    value: "email"
  },
  {
    text: "Tipo Utilizador",
    align: "left",
    value: "tipo_utilizador"
  },
  /*{
    text: "Instituição",
    align: "left",
    value: "instituicao"
  },*/
  {
    text: "Estado",
    align: "left",
    value: "estado"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const UTILIZADOR = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default UTILIZADOR
